// extracted by mini-css-extract-plugin
module.exports = {"model":"PasswordChange_model__2rbmt","content":"PasswordChange_content__2DTb1"};